<div style="min-height: 50px;overflow: hidden;">
    <div style="float:left;">
        <div class="alert-title" *ngIf="archivo">{{etiquetasService.getEtiqueta('comparador', 'borrar')}} "{{archivo.nombre}}"</div>
        <span [class.success-message]="true">{{etiquetasService.getEtiqueta('comparador', 'borrarConfirmacion')}}</span>
    </div>
    <div class="snackButtonContainer text-center">
        <button mat-button color="warn" class="snackButton" (click)="deleteMultimedia(archivo.idMultimedia)">{{etiquetasService.getEtiqueta('comparador', 'borrar')}}</button>
        <button mat-button class="snackButton" (click)="cancelar()">{{etiquetasService.getEtiqueta('comparador', 'cancelar')}}</button>
    </div>
</div>